<template>
  <div>
    <input
      type="email"
      @input="$emit('input',{value: $event.target.value})"
      placeholder="joe@example.com"
      :value="value"
      :required="required != null ? required : true"
    />
  </div>
</template>

<script>
export default {
  computed: {
    value () {
      return this.$store.state.userData[this.dataKey]
    }
  },
  props: ['options', 'data-key', 'required']
}
</script>
